import { CaretRightOutlined, SoundOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import useQuestionAudio from './useQuestionAudio.hook';
import { StyledQuestionAudio } from './QuestionAudio.styled';

export default function QuestionAudio({
  audioId,
  audio,
  disabled,
  onPlay,
  onEnded,
}) {
  const { state, actions } = useQuestionAudio({
    audioId,
    audio,
    onPlay,
    onEnded,
  });
  return (
    <StyledQuestionAudio>
      <Button
        icon={state.playing ? <SoundOutlined /> : <CaretRightOutlined />}
        shape="circle"
        onClick={actions.play}
        size="small"
        disabled={disabled}
        loading={state.loading}
      />
    </StyledQuestionAudio>
  );
}
